import { render, staticRenderFns } from "./AiRirekishoEdit.vue?vue&type=template&id=80852d68&scoped=true"
import script from "./AiRirekishoEdit.vue?vue&type=script&lang=js"
export * from "./AiRirekishoEdit.vue?vue&type=script&lang=js"
import style0 from "./AiRirekishoEdit.vue?vue&type=style&index=0&id=80852d68&prod&lang=scss&scoped=true"
import style1 from "./AiRirekishoEdit.vue?vue&type=style&index=1&id=80852d68&prod&scoped=true&lang=css"
import style2 from "./AiRirekishoEdit.vue?vue&type=style&index=2&id=80852d68&prod&scoped=true&lang=css"
import style3 from "./AiRirekishoEdit.vue?vue&type=style&index=3&id=80852d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80852d68",
  null
  
)

export default component.exports